<template>
  <div class="side-rank">
    <template v-if="isInterdict">
      <Interdict layout="column"></Interdict>
    </template>
    <template v-else>
      <div class="side-rank-title">
        <i></i>
        本局比赛战队赠礼排行
      </div>
      <div class="side-rank-center">
        <div class="user">
          <div class="user-item" v-for="(item, index) in fanListTop3" :key="index">
            <div class="user-text">
              <div
                class="user-img"
                :style="{
                  'background-image': `url(${
                    item?.avatarUrl || defaultUrl
                  })`
                }"
              >
              </div>
              <div class="rank" :data-rank="`rank-${index + 1}`">
                <div class="label-box">
                  <span class="label-shadow">NO.{{ index + 1 }}</span>
                  <span class="label-text">NO.{{ index + 1 }}</span>
                </div>
              </div>
            </div>
            <div class="user-name">
              <div class="label-box">
                <span class="label-shadow">{{ item?.nickName }}</span>
                <span class="label-text">{{ item?.nickName }}</span>
              </div>
            </div>
            <div class="popularity" :data-rank="`rank-${index + 1}`">
              <i class="place"></i>
              <div class="label-box">
                <span class="label-shadow">
                  {{ item?.popularity >= 10000 ? (item?.popularity / 10000).toFixed(2) + '万' : item?.popularity }}
                </span>
                <span class="label-text">
                  {{ item?.popularity >= 10000 ? (item?.popularity / 10000).toFixed(2) + '万' : item?.popularity }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="fan-rank">
          <div
            class="list-item"
            v-show="filteredList.length > 0"
            v-for="(item, index) in filteredList"
            :key="index"
          >
            <div class="first">
              <div class="label-box">
                <span class="label-shadow">{{ index + 4 }}</span>
                <span class="label-text">{{ index + 4 }}</span>
              </div>
            </div>
            <div class="nanu">
              <div
                class="avatar"
                :style="{
                  'background-image': `url(${item.avatarUrl || defaultUrl})`
                }"
              >
              </div>
              <div class="name">
                {{ item.nickName }}
              </div>
            </div>
            <div class="hot">
              {{countShow( item.popularity)}}
            </div>
          </div>

          <!-- <div class="fan-cneter"></div> -->
        </div>
        <ui-frame-bg class="side-rank-bottom" colorType="yellow" @click.native="linkTo('Ranking')">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">赠礼排行榜</span>
            <span class="label-text">赠礼排行榜</span>
          </div>
        </ui-frame-bg>
        <!-- <div class="side-rank-bottom" @click="linkTo('Ranking')">
        </div> -->
      </div>
    </template>
  </div>
</template>


<script>
import { mapState } from 'vuex'
import * as api from '@/service/index'
import Interdict from '@/components/interdict'
import UiFrameBg from '@/components/ui-frame-bg'
export default {
  components: {
    Interdict,
    UiFrameBg
  },
  props: {
    // fanList: Array,
    rankType: String
  },
  data() {
    return {
      fanList: [],
      defaultUrl: 'https://website.xdcdn.net/form/match/avatar/Portrait1.png'
    }
  },
  created() {
    // 不显示送礼模块时，拦截不必要的请求
    if(!this.isInterdict) {
      this.livePersonalRanking()
    }
  },
  computed: {
    ...mapState(['token','isInterdict']),
    fanListTop3() {
      return this.fanList?.filter((item, index) => index <= 2)
    },
    filteredList() {
      return this.fanList?.filter((item, index) => index > 2)
    }
  },
  methods: {
    async livePersonalRanking() {
      try {
        if(!this.token) return;
        let { status, data } = await api.getPersonalRanking(this.token)
        if (status === 200) {
          this.fanList = data.totalList
        }
      } catch (err) {
        console.log(err)
      }
    },
    linkTo(name) {
      this.$router.push({
        name: name
      })
    },
    countShow(hot){
      if(hot){
        if(hot<10000){
          return hot
        }else if(10000 <= hot && hot < 99999999){
          return (((hot / 10000)* 100) /100).toFixed(2) + '万'
        }else {
          return  9999 +'万+'
        }
      }else{
        return  0
      }
    },
  }
}
</script>


<style lang="scss" scoped>
@import '~@/assets/scss/live/sideRank';
</style>